import { Signal } from "typed-signals";
import { LayoutController } from "onearm";

/**
 * @class SpinButtonsController
 * @description Controller for spin/stop buttons with SFX configuration
 */
export class SpinButtonsController extends LayoutController {
    init() {
        this.onPressSpin = new Signal();
        this.onPressStop = new Signal();

        this.connectButton("SpinButton", this.onPressSpin);
        this.connectButton("StopButton", this.onPressStop);

        this.setupSfx();
        this.setSpinState();
    }

    setupSfx() {
        this.forAll("SpinButton", (btn) => {
            btn.sfx.press = "spin_start_btn";
        });

        this.forAll("StopButton", (btn) => {
            btn.sfx.press = "spin_stop_btn";
        });
    }

    /**
     * @description Show spin button, hide stop button
     */
    setSpinState() {
        this.setVisible("SpinButton", true);
        this.setVisible("StopButton", false);
    }

    /**
     * @description Show stop button, hide spin button
     */
    setStopState() {
        this.setVisible("SpinButton", false);
        this.setVisible("StopButton", true);
    }

    /**
     * @description Enable/disable spin and stop buttons
     * @param {boolean} enabled
     */
    setButtonsEnabled(enabled) {
        this.setEnabled("SpinButton", enabled);
        this.setEnabled("StopButton", enabled);
    }

    onEnabledChange(value) {
        this.setButtonsEnabled(value);
    }
}

export class WinCounterController extends LayoutController {
    set value(value) {
        this._value = value;
        this.updateTextValue(value);
    }

    get value() {
        return this._value;
    }

    updateTextValue(value) {
        this.forAll(this.options.winValueTextName, (text) => {
            text.text = this.options.format(value);
        });
    }

    countTo(parameters) {
        const { duration = 1, value} = parameters;
        const timeline = gsap.timeline();

        timeline.to(this, { value, duration });

        return timeline;
    }
}
